import React, { createContext, useContext, useState, useCallback } from 'react';

type Widget = 'chat' | 'faq' | 'whatsapp' | null;

interface WidgetContextType {
  activeWidget: Widget;
  open: (w: Widget) => void;
  close: () => void;
  toggle: (w: Widget) => void;
}

const WidgetContext = createContext<WidgetContextType>({
  activeWidget: null,
  open: () => {},
  close: () => {},
  toggle: () => {},
});

export function WidgetProvider({ children }: { children: React.ReactNode }) {
  const [activeWidget, setActiveWidget] = useState<Widget>(null);
  const open = useCallback((w: Widget) => setActiveWidget(w), []);
  const close = useCallback(() => setActiveWidget(null), []);
  const toggle = useCallback((w: Widget) => setActiveWidget(prev => prev === w ? null : w), []);
  return (
    <WidgetContext.Provider value={{ activeWidget, open, close, toggle }}>
      {children}
    </WidgetContext.Provider>
  );
}

export const useWidget = () => useContext(WidgetContext);
